// extracted by mini-css-extract-plugin
module.exports = {"placeholder":"StoryPlaceholder_placeholder__X_N66"};